export default (Component, shouldRenderKey = "shouldRender") => ({ ...props }) => (props[shouldRenderKey] ?? true) && <Component {...props} />